import {ALERT_ADD, ALERT_REMOVE, DANGER_ALERT_TYPE, SUCCESS_ALERT_TYPE} from './TransientNotificationConstants';

export function createAlert(type, message, title) {
	const msg = {
		type,
		message,
		title
	};

	return {
		type: ALERT_ADD,
		alert: msg
	};
}

export function addAlert(message) {
	return createAlert(DANGER_ALERT_TYPE, message);
}

export function addSuccess(message, title) {
	return createAlert(SUCCESS_ALERT_TYPE, message, title);
}

export function removeAlert(id) {
	return {
		type: ALERT_REMOVE,
		id
	};
}